<div mat-dialog-content>
    <form
    [formGroup]="entityFormGroup"
    fxLayout="column"
    aria-describedby="user portal group table"
    >
      <div
        *ngIf="entityFormGroup.errors?.['username'] && (entityFormGroup.touched || entityFormGroup.dirty)"
        class="error-msg">
        "I Dati inseriti nei campi password e username sono troppo simili"
      </div>
      <!-- OLD Pass form field -->
      <mat-form-field appearance="fill">
        <mat-label>{{ "user.field.old_password" | translate }}</mat-label>
        <input matInput  type="{{(oldPassword === false)?'password':'text'}}" formControlName="old_password">
        <mat-icon matSuffix style="cursor: pointer;" (click)="toggleOldPassword()">
          {{!oldPassword?'visibility':'visibility_off'}}</mat-icon>
        <mat-error *ngIf="entityFormGroup.get('old_password')?.hasError('required')">{{
          "common.dialog.errors.required" | translate
          }}</mat-error>
        <mat-error *ngIf="entityFormGroup.get('old_password')?.hasError('maxlength')">
          {{ "common.dialog.errors.maxLength" | translate }}
        </mat-error>
        <mat-error *ngIf="entityFormGroup.get('old_password')?.hasError('minlength')">
          {{ "common.dialog.errors.minLength" | translate }}
        </mat-error>
      </mat-form-field>
      <div
        *ngIf="entityFormGroup.errors?.['app-user-form'] && (entityFormGroup.touched || entityFormGroup.dirty)"
        class="error-msg">
        "I Dati inseriti nei campi password devono essere identici"
      </div>
      <!-- Pass form field -->
      <mat-form-field appearance="fill">
        <mat-label>{{ "user.field.new_password1" | translate }}</mat-label>
        <input matInput  type="{{(showPassword === false)?'password':'text'}}" formControlName="new_password1">
        <mat-icon matSuffix style="cursor: pointer;" (click)="toggleShowPassword()">
          {{!showPassword?'visibility':'visibility_off'}}</mat-icon>
        <mat-error *ngIf="entityFormGroup.get('new_password1')?.hasError('required')">{{
          "common.dialog.errors.required" | translate
          }}</mat-error>
        <mat-error *ngIf="entityFormGroup.get('new_password1')?.hasError('maxlength')">
          {{ "common.dialog.errors.maxLength" | translate }}
        </mat-error>
        <mat-error *ngIf="entityFormGroup.get('new_password1')?.hasError('minlength')">
          {{ "common.dialog.errors.minLength" | translate }}
        </mat-error>
      </mat-form-field>
      <!-- Pass2 form field -->
      <mat-form-field appearance="fill">
        <mat-label>{{ "user.field.new_password2" | translate }}</mat-label>
        <input matInput  type="{{(showConfirmPassword === false)?'password':'text'}}" formControlName="new_password2">
        <mat-icon matSuffix style="cursor: pointer;" (click)="toggleShowConfirmPassword()">
          {{!showConfirmPassword?'visibility':'visibility_off'}}</mat-icon>
        <mat-error *ngIf="entityFormGroup.get('new_password2')?.hasError('required')">{{
          "common.dialog.errors.required" | translate
          }}</mat-error>
        <mat-error *ngIf="entityFormGroup.get('new_password2')?.hasError('maxlength')">
          {{ "common.dialog.errors.maxLength" | translate }}
        </mat-error>
        <mat-error *ngIf="entityFormGroup.get('new_password2')?.hasError('minlength')">
          {{ "common.dialog.errors.minLength" | translate }}
        </mat-error>
      </mat-form-field>
    </form>
    <div mat-dialog-actions fxLayoutAlign="center center">
    <button mat-button mat-dialog-close>
      {{ "common.dialog.cancel" | translate }}
    </button>
    <button mat-button cdkFocusInitial color="primary" (click)="saveClicked()">
      {{ "common.dialog.save" | translate }}
    </button>
    </div>
  </div>
  